import { inject, InjectionToken } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import firebase from 'firebase/compat/app';
import { map, Observable, share } from 'rxjs';
import { PushData } from './messaging-push.model';

export const PUSH_ACTION = new InjectionToken<Observable<PushData>>('Firebase push messaging action stream', {
  factory: () =>
    inject(AngularFireMessaging).messages.pipe(
      map((message: firebase.messaging.MessagePayload) => {
        return {
          ...message.data,
          itemId: parseInt(message.data!['itemId']),
        } as PushData;
      }),
      share()
    ),
});
